import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { benefitApi, couponApi } from "@api";
import {
    ArrowRight,
    ComponentHeaderAuth,
    ComponentNewProfile,
    ComponentProfile,
    ComponentQRcode,
    IconPrivacy,
    StyledHome,
} from "@components";
import {
    INITIAL_LIST_PARAMS,
    PATH_PRIVACY_MANAGEMENT,
    PATH_PRIVILEGE,
    PATH_PROFILE,
    PATH_TERM_AND_CONDITION,
    PATH_TIER_DETAIL,
    PATH_WELCOME,
    enumNavigation,
} from "@configs";
import { IPagination } from "@interfaces";
import {
    logout,
    resetAuth,
    resetLineToken,
    selectAuth,
    selectMerchant,
    selectNotSaveLocal,
    setNavigationType,
} from "@redux";
import { Col, Row, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { LangDropdown } from "src/Components/LangDropdown";
import { IconLogout } from "src/Components/icon/Logout";
import { IconPdpa } from "src/Components/icon/Pdpa";
import { IconTandC } from "src/Components/icon/TandC";
import styled from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

export const PageProfile = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const [parambenefit, setParamBenefit] = useState<IPagination>(INITIAL_LIST_PARAMS);
    const [paramcoupon, setParamCoupon] = useState<IPagination>(INITIAL_LIST_PARAMS);
    const { t } = useTranslation();
    const { navigationType } = useSelector(selectNotSaveLocal);
    //page state
    const [showQrCode, setShowQrCode] = useState<boolean>(false);
    const [totalbenefit, setTotalBenefit] = useState<number>(0);
    const [totalcoupon, setTotalCoupon] = useState<number>(0);
    const [isLoading, setIsloading] = useState(false);

    const prefix = window.location.hostname.split(".")[0];

    // const setColor = merchant.themeColorSecound;
    const setColor = "#f6f6f6";

    const hexToRgb = (setColor: any) => {
        // Remove the '#' character if present
        setColor = setColor.replace("#", "");

        // Convert the hex code to RGB
        const r = parseInt(setColor.substring(0, 2), 16);
        const g = parseInt(setColor.substring(2, 4), 16);
        const b = parseInt(setColor.substring(4, 6), 16);

        return `linear-gradient(0deg,rgba(${r}, ${g}, ${b}, 0.2) 65%,rgba(${r}, ${g}, ${b}, 1) 100%)`;
    };

    const rgbColor = hexToRgb(setColor);

    useEffect(() => {
        (async () => {
            const res = await benefitApi.getListBenefit(parambenefit);
            setTotalBenefit(res.data?.length);
        })();
    }, []);

    useEffect(() => {
        setIsloading(true);
        (async () => {
            const res = await couponApi.getListCoupon(paramcoupon);
            setTotalCoupon(res.data.totalDocs);
            setIsloading(false);
        })();
    }, []);

    const handleToggleUnder = (values: enumNavigation) => {
        dispatch(setNavigationType(values));
    };

    const handleToggleQrCode = () => {
        setShowQrCode(!showQrCode);
    };

    const handleSwitchUserSetting = () => {
        // history.push(PATH_USER_SETTING);
        history.push(PATH_PROFILE);
    };

    const handleSwitchTier = () => {
        history.push(PATH_TIER_DETAIL);
    };

    const handleInitalQrCode = () => {
        setShowQrCode(false);
    };
    const handleClickPdpa = () => {
        history.push(PATH_PRIVACY_MANAGEMENT);
    };
    const handleClickTerm = () => {
        history.push(PATH_TERM_AND_CONDITION);
    };
    const handleLogout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        // if (liff.isInClient()) {
        //     liff.closeWindow();
        // }
        await dispatch(resetLineToken());
        await dispatch(resetAuth());
        await dispatch(logout());
        await history.push(PATH_WELCOME);
    };

    const renderCorporateUi = () => {
        if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi === true) {
            return (
                <StyleCoporate color={rgbColor} themeColor={themes?.themeColor!}>
                    <div className="corp-lang">
                        <LangDropdown />
                    </div>

                    <StyleCoporateProfile>
                        <ComponentNewProfile
                            under={navigationType}
                            handleToggleUnder={handleToggleUnder}
                            userInfo={userInfo}
                            memberShipTiers={memberShipTiers || []}
                            themeColor={themes?.themeColor!}
                            handleToggleQrCode={handleToggleQrCode}
                            handleSwitchUserSetting={handleSwitchUserSetting}
                            handleSwitchTier={handleSwitchTier}
                        />
                    </StyleCoporateProfile>
                    <StyledNewProfile themeColor={themes?.themeColor!}>
                        <div className="wrapper-newprofile">
                            <div className="layout-twoframe">
                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <div className="box-twoframe">
                                            <Skeleton
                                                loading={isLoading}
                                                active
                                                title={true}
                                                paragraph={{ rows: 1, width: [64] }}
                                            >
                                                <p>
                                                    <span>{totalcoupon}</span>
                                                    {t("page.coupons")}
                                                </p>
                                                <span
                                                    className="link"
                                                    onClick={() =>
                                                        history.push(PATH_PRIVILEGE + "/coupon")
                                                    }
                                                >
                                                    {t("page.view")}
                                                </span>
                                                {/* <div className="banner-new">NEW</div> */}
                                            </Skeleton>
                                        </div>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <div
                                            className="box-twoframe"
                                            onClick={() =>
                                                prefix !== "futurepark" &&
                                                history.push(PATH_PRIVILEGE + "/benefit")
                                            }
                                        >
                                            <Skeleton
                                                loading={isLoading}
                                                active
                                                title={true}
                                                paragraph={{ rows: 1, width: [64] }}
                                            >
                                                <p>
                                                    <span>{totalbenefit}</span>
                                                    {t("page.benefits")}
                                                </p>
                                                <span
                                                    className="link"
                                                    onClick={() =>
                                                        prefix !== "futurepark" &&
                                                        history.push(PATH_PRIVILEGE)
                                                    }
                                                >
                                                    {t("page.view")}
                                                </span>
                                            </Skeleton>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {/* <div className="wrapper-slide-product-profile">
                                <Swiper
                                    slidesPerView={1.2} spaceBetween={15}
                                >
                                    <SwiperSlide>
                                        <div className="layout-slide-product-profile">
                                            <div className="box-newproduct">
                                                <a href="">
                                                    <img src="../images/new-product-01.png" alt="covernewproduct" />
                                                </a>
                                            </div>
                                            <div className="topic-newproduct">New Product</div>
                                            <div className="name-newproduct">
                                                Kuliko Drink <span>1+1</span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="layout-slide-product-profile">
                                            <div className="box-newproduct">
                                                <a href="">
                                                    <img src="../images/new-product-01.png" alt="covernewproduct" />
                                                </a>
                                            </div>
                                            <div className="topic-newproduct">New Product</div>
                                            <div className="name-newproduct">
                                                Kuliko Drink <span>1+1</span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="layout-slide-product-profile">
                                            <div className="box-newproduct">
                                                <a href="">
                                                    <img src="../images/new-product-01.png" alt="covernewproduct" />
                                                </a>
                                            </div>
                                            <div className="topic-newproduct">New Product</div>
                                            <div className="name-newproduct">
                                                Kuliko Drink <span>1+1</span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div> */}
                            <div className="wrapper-setting-profile">
                                <div className="topic-setting-profile">
                                    <Skeleton loading={false} active title={true} paragraph={false}>
                                        {t("page.setting")}
                                    </Skeleton>
                                </div>
                                <div className="content-setting-profile">
                                    {/* <div className="menu-item" onClick={handleClickPdpa}>
                                    <div className="icon-name">
                                        <span><IconHistory /></span>
                                        <p>History Redeem</p>
                                    </div>
                                    <div className="arrow">
                                        <ArrowRight size={10} />
                                    </div>
                                </div> */}
                                    {/* <div className="menu-item" onClick={() => history.push()}>
                                    <div className="icon-name">
                                        <span><IconNoti /></span>
                                        <p>Notification</p>
                                    </div>
                                    <div className="arrow">
                                        <ArrowRight size={10} />
                                    </div>
                                </div> */}
                                    {/* <div className="menu-item" onClick={handleClickPdpa}>
                                    <div className="icon-name">
                                        <span><IconPrivacy /></span>
                                        <p>Change Language</p>
                                    </div>
                                    <div className="arrow">
                                        <ArrowRight size={10} />
                                    </div>
                                </div> */}
                                    {/*<div className="menu-item" onClick={handleClickPdpa}>
                                    <div className="icon-name">
                                        <span><IconChange /></span>
                                        <p>Terms & Conditions</p>
                                    </div>
                                    <div className="arrow">
                                        <ArrowRight size={10} />
                                    </div>
                                </div> */}
                                    <Skeleton
                                        avatar
                                        loading={false}
                                        active
                                        title={false}
                                        paragraph={{ rows: 1 }}
                                    >
                                        <div className="menu-item" onClick={handleClickPdpa}>
                                            <div className="icon-name">
                                                <span>
                                                    <IconPdpa color={themes?.themeColor} />
                                                </span>
                                                <p>PDPA</p>
                                            </div>
                                            <div className="arrow">
                                                <ArrowRight size={10} />
                                            </div>
                                        </div>
                                    </Skeleton>
                                    <Skeleton
                                        avatar
                                        loading={false}
                                        active
                                        title={false}
                                        paragraph={{ rows: 1 }}
                                    >
                                        <div className="menu-item" onClick={handleClickTerm}>
                                            <div className="icon-name">
                                                <span>
                                                    <IconTandC color={themes?.themeColor} />
                                                </span>
                                                <p>Term And Condition</p>
                                            </div>
                                            <div className="arrow">
                                                <ArrowRight size={10} />
                                            </div>
                                        </div>
                                    </Skeleton>
                                    {/* <div className="menu-item" onClick={handleClickPdpa}>
                                    <div className="icon-name">
                                        <span><IconSetting /></span>
                                        <p>Settings</p>
                                    </div>
                                    <div className="arrow">
                                        <ArrowRight size={10} />
                                    </div>
                                </div> */}
                                    <Skeleton
                                        avatar
                                        loading={false}
                                        active
                                        title={false}
                                        paragraph={{ rows: 1 }}
                                    >
                                        <div className="menu-item" onClick={handleLogout}>
                                            <div className="icon-name">
                                                <span>
                                                    <IconLogout color={themes?.themeColor} />
                                                </span>
                                                <p className="textred">{t("page.logout")}</p>
                                            </div>
                                            <div className="arrow">
                                                <ArrowRight size={10} />
                                            </div>
                                        </div>
                                    </Skeleton>
                                </div>
                            </div>
                        </div>
                    </StyledNewProfile>
                </StyleCoporate>
            );
        } else {
            return (
                <>
                    {!showQrCode && (
                        <>
                            <ComponentProfile
                                under={navigationType}
                                handleToggleUnder={handleToggleUnder}
                                userInfo={userInfo}
                                memberShipTiers={memberShipTiers || []}
                                themeColor={themes?.themeColor!}
                                handleToggleQrCode={handleToggleQrCode}
                                handleSwitchUserSetting={handleSwitchUserSetting}
                                handleSwitchTier={handleSwitchTier}
                                // handleCoupon={handleCoupon}
                            />
                            {/* <StyledContainerHome className="home-nab-detail">
                            {render()}
                        </StyledContainerHome> */}
                        </>
                    )}
                    {showQrCode && <ComponentQRcode handleToggleQrCode={handleToggleQrCode} />}
                    {!showQrCode && (
                        <StyledProfileMenu>
                            <div className="menu-item righttoleft" onClick={handleClickPdpa}>
                                <div className="icon-name">
                                    <IconPrivacy size={28} />
                                    <p>{t("page.data_privacy")}</p>
                                </div>
                                <div className="arrow">
                                    <ArrowRight size={10} />
                                </div>
                            </div>
                            <div className="menu-item righttoleft3s" onClick={handleLogout}>
                                <div className="icon-name">
                                    <div className="no-icon">&nbsp;</div>
                                    <p>{t("page.logout")}</p>
                                </div>
                                <div className="arrow">
                                    <ArrowRight size={10} />
                                </div>
                            </div>
                        </StyledProfileMenu>
                    )}
                </>
            );
        }
    };

    return (
        <ComponentHeaderAuth handleInitalQrCode={handleInitalQrCode}>
            <StyledHome mainColor={themes?.themeColor!}>
                {renderCorporateUi()}
                {/* <ComponentFooter /> */}
            </StyledHome>
        </ComponentHeaderAuth>
    );
};
const StyleCoporateProfile = styled.div`
    .preview {
        background-color: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        border-radius: 0 !important;
        border: none !important;
    }
`;
const StyleCoporate = styled.div<{ themeColor: string }>`
    position: relative;
    /* top: -112px; */
    margin-top: 0;
    padding: 40px 0;
    // background: rgb(246,246,246);
    // background: linear-gradient(0deg, rgba(246,246,246,1) 68%, rgba(240,234,214,1) 100%);
    background: ${(props) => props.color};
    background-color: #dfdfdf;
    height: 100dvh;
    .corp-lang {
        position: absolute;
        z-index: 999;
        right: 0;
        top: 0;
        padding: 15px;
    }
    // &:after {
    //     content: '';
    //     background-color: #e4e4e4;
    //     position: absolute;
    //     height: 112px;
    //     bottom: -112px;
    //     left: 0;
    //     width: 100%;
    // }
`;

const StyledNewProfile = styled.div<{ themeColor: string }>`
    padding: 20px 16px;
    .layout-twoframe {
        margin-bottom: 15px;
        .box-twoframe {
            padding: 14px 16px 18px;
            border-radius: 14px;
            background-color: #fff;
            position: relative;
            .ant-skeleton {
                .ant-skeleton-title {
                    width: 100% !important;
                    height: 10px;
                    margin-top: 12px;
                    border-radius: 4px;
                }
                .ant-skeleton-paragraph {
                    li {
                        width: 64px;
                        height: 10px;
                        border-radius: 4px;
                        margin-top: 0;
                        margin-bottom: 3px;
                    }
                }
            }
            // @media (max-width: 400px) {
            //     margin-bottom: 15px;
            //     display: flex;
            //     justify-content: space-between;
            //     align-items: center;
            // }
            p {
                font-size: 14px;
                line-height: 20px;
                color: #000;
                margin-bottom: 0;
                span {
                    font-size: 32px;
                    line-height: 38px;
                    color: ${(p) => p.themeColor};
                    font-weight: 500;
                    margin-right: 5px;
                    position: relative;
                    top: 0;
                }
            }
            span.link {
                font-size: 14px;
                line-height: 20px;
                font-weight: 600;
                color: #000;
                display: inline-block;
                background-image: url(../../images/ic-next.svg);
                background-size: 6px;
                background-position: right center;
                background-repeat: no-repeat;
                padding-right: 20px;
            }
            .banner-new {
                position: absolute;
                right: 16px;
                top: 10px;
                background-color: #336c51;
                padding: 2px 5px 2px 5px;
                color: #fff;
                font-size: 14px;
                border-radius: 34px;
                font-weight: 500;
            }
        }
    }
    .wrapper-slide-product-profile {
        .layout-slide-product-profile {
            position: relative;
            margin-bottom: 15px;
            padding: 20px 16px;
            border-radius: 14px;
            padding-right: 90px;
            background-color: #fff;
            .box-newproduct {
                position: absolute;
                right: 16px;
                top: 50%;
                transform: translateY(-50%);
                a {
                    img {
                        max-width: 100%;
                    }
                }
            }
            .topic-newproduct {
                font-size: 12px;
                color: #9b9b9b;
            }
            .name-newproduct {
                font-size: 16px;
                line-height: 20px;
                color: #000;
                font-weight: 600;
                span {
                    color: #336c51;
                    font-weight: 700;
                }
            }
        }
    }
    .wrapper-setting-profile {
        padding: 20px 16px 16px 16px;
        background-color: #fff;
        border-radius: 14px;
        .topic-setting-profile {
            font-size: 16px;
            font-weight: 600;
            color: #000;
            margin-bottom: 10px;
            .ant-skeleton {
                margin-bottom: 15px;
                .ant-skeleton-title {
                    width: 66px !important;
                    margin-top: 0;
                    height: 10px;
                    border-radius: 4px;
                }
            }
        }
        .content-setting-profile {
            .ant-skeleton {
                margin-bottom: 24px;
                .ant-skeleton-avatar {
                    border-radius: 4px !important;
                }
                .ant-skeleton-paragraph {
                    margin-top: 12px;
                    li {
                        height: 10px;
                        width: 140px !important;
                        margin-top: 12px;
                        border-radius: 4px;
                    }
                }
            }
        }
        .menu-item {
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            padding: 10px 0;

            .icon-name {
                font-size: 16px;
                font-weight: 600;
                display: flex;
                align-items: center;
                span {
                    width: 25px;
                    text-align: center;
                }
                p {
                    margin: 2px 0px 0px 10px;
                    color: #000;
                }
                .no-icon {
                    width: 24px;
                }
                .textred {
                    color: #ff0000;
                }
            }
        }
    }
`;
const StyledProfileMenu = styled.div`
    margin: 20px;
    margin-top: 30px;
    .menu-item {
        background-color: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        padding: 15px;
        box-shadow: 0px 0px 8px rgba(175, 175, 175, 0.14);
        // animation: righttoleft 1s!important;
        // position:relative;
        // @keyframes righttoleft {
        //     0%   {left:100%}
        //     100% {left: 0%;}
        // }
        .icon-name {
            font-size: 16px;
            font-weight: 600;
            display: flex;
            p {
                margin: 2px 0px 0px 5px;
            }
            .no-icon {
                width: 24px;
            }
        }
    }
`;
